import { ProjectCostDistributionChartPointsDocument } from 'generated/resources/graphql'
import moment, { Moment } from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

import {
  graphViewsDetailViewOptionEnum,
  overviewFrequencyOptionsEnum,
} from 'modules/project_management/lib/constants'
import { formatYAxisWithLargeNumbers } from 'modules/project_management/lib/formatChartComponents'
import { maxLengthOfLabelsArray } from 'modules/project_management/lib/overviewOptions'

import { ResponsiveBarChart } from '../../ResponsiveBarChart'
import {
  DetailTransformedData,
  getCostDistributionTransformedData,
} from '../getDistributionTransformedData'

interface CostDistributionChartProps {
  projectId: number
  startDate?: Moment
  endDate?: Moment
  selectedFrequency: overviewFrequencyOptionsEnum
  selectedOption: graphViewsDetailViewOptionEnum
  currency: string
}

export const CostDistributionChart: React.FC<CostDistributionChartProps> = ({
  projectId,
  startDate = moment().startOf('week'),
  endDate = moment().endOf('week'),
  selectedFrequency,
  selectedOption,
  currency,
}) => {
  const maxLabels = maxLengthOfLabelsArray(selectedFrequency)

  const { loading, error, data } = useQuery(ProjectCostDistributionChartPointsDocument, {
    variables: {
      projectId: projectId,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      slotType: selectedFrequency,
      includeEmployees: selectedOption === 'employees',
      includeSubprojects: selectedOption === 'subprojects',
    },
  })

  const projectCostDistributionChartPoints =
    data?.projectManagement?.projectCostDistributionChartPoints || []

  const transformedData: DetailTransformedData = getCostDistributionTransformedData(
    projectCostDistributionChartPoints,
    selectedOption,
    selectedFrequency
  )

  const formatYAxis = (value: number) => {
    return formatYAxisWithLargeNumbers(value, currency)
  }

  return (
    <ResponsiveBarChart
      detailData={transformedData}
      unit={currency}
      formatYAxis={formatYAxis}
      maxLabels={maxLabels}
      loading={loading}
      error={error}
    />
  )
}
